import { render, staticRenderFns } from "./DrawerHistoricoAgricola.vue?vue&type=template&id=5e367afb&lang=pug"
import script from "./DrawerHistoricoAgricola.vue?vue&type=script&lang=js"
export * from "./DrawerHistoricoAgricola.vue?vue&type=script&lang=js"
import style0 from "./DrawerHistoricoAgricola.vue?vue&type=style&index=0&id=5e367afb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports